<main>
  <app-slider></app-slider>
  <app-search-page-section></app-search-page-section>
  <app-categories-services></app-categories-services>
  <app-news-page-section></app-news-page-section>
</main>
